import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {CollageFilterDialogComponent} from '../dialogs/collage-filter-dialog/collage-filter-dialog.component';
import {CollageFilterModel} from '../models/collage-filter.model';
import {CollageService} from '../../../../services/collage.service';
import {DocumentDataModel} from '../../../../models/document/document-data.model';

@Component({
  selector: 'app-collage-nav',
  templateUrl: './collage-nav.component.html',
  styleUrls: ['./collage-nav.component.scss']
})
export class CollageNavComponent implements OnInit {
  @Output() filterChange = new EventEmitter<CollageFilterModel>();

  navOpen: boolean = true;
  collages: DocumentDataModel[][] = [];
  filterModel: CollageFilterModel;

  constructor(private dialog: MatDialog,
              private collageService: CollageService) { }

  ngOnInit(): void {
    const ls = localStorage.getItem('collage-filter');
    if (ls) {
      this.filterModel = JSON.parse(ls) as CollageFilterModel;
      this.filterModel.startDate = new Date(this.filterModel.startDateMs);
      this.filterModel.endDate = new Date(this.filterModel.endDateMs);
    }

    if (!this.filterModel) {
      this.filterModel = new CollageFilterModel();
    }
  }

  onOpenFilterDialog() {
    const configs = new MatDialogConfig();
    configs.panelClass = 'dialog';
    configs.data = this.filterModel;
    this.dialog.open(CollageFilterDialogComponent, configs).afterClosed().subscribe((res) => {
      if (res) {
        // this.filterChange.emit(res);
        this.collageService.getCollages(res).subscribe((collageResponse) => {

        });
      }
    });
  }

  getFetchLabel() {
    if (this.filterModel) {
      if (this.filterModel.fetchCount > -1) {
        return 'Top ' + this.filterModel.fetchCount;
      } else {
        return 'All';
      }
    } else {
      return '';
    }
  }
}
